import type { FC } from "react";

import { InfoBanner as UIInfoBanner } from "@jti/ui/components/InfoBanner";

import type { infoBannerInputs } from "./InfoBanner.builder";

type InfoBannerBuilderProps = BuilderComponentProps<typeof infoBannerInputs>;

export const InfoBanner: FC<InfoBannerBuilderProps> = (props) => {
  return <UIInfoBanner {...props} />;
};
